export default __webpack_public_path__ + "static/media/Tunic of the Exorcist.e4c9e715.jpg";